// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ButtonCmpModuleScss from "../styles/ButtonCmp.module.scss";

var styles = ButtonCmpModuleScss;

function ButtonCmp(Props) {
  var on_click = Props.on_click;
  var class_nameOpt = Props.class_name;
  var children = Props.children;
  var class_name = class_nameOpt !== undefined ? class_nameOpt : styles.btn;
  return React.createElement("button", {
              className: class_name,
              onClick: (function (param) {
                  Curry._1(on_click, undefined);
                })
            }, children);
}

var make = ButtonCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
